import { useRef, useEffect } from "react";
import { analytics, setAnalyticsContext } from "../../lib/analytics";
import { setSentryOrg } from "../../lib/sentry";

interface VisitorAnalyticsOptions {
  orgSlug: string;
  mapSlug: string;
  refParam: string | undefined;
  organizationSlug: string | undefined;
  dataUpdatedAt: number | undefined;
}

export function useVisitorAnalytics({
  orgSlug,
  mapSlug,
  refParam,
  organizationSlug,
  dataUpdatedAt,
}: VisitorAnalyticsOptions) {
  // Track view_map on mount (once)
  const hasTrackedView = useRef(false);
  useEffect(() => {
    if (!hasTrackedView.current) {
      hasTrackedView.current = true;
      setAnalyticsContext({ map_slug: mapSlug, org_slug: orgSlug });
      setSentryOrg(orgSlug);
      analytics.viewMap({ ref: refParam });
    }
  }, [mapSlug, orgSlug, refParam]);

  // Track when map data was last fetched (for offline indicator)
  const fetchedAtRef = useRef<number>(Date.now());
  useEffect(() => {
    if (dataUpdatedAt) {
      fetchedAtRef.current = dataUpdatedAt;
    }
  }, [dataUpdatedAt]);

  // Set org context for analytics when mapData loads
  useEffect(() => {
    if (organizationSlug) {
      setAnalyticsContext({ org_slug: organizationSlug });
    }
  }, [organizationSlug]);

  return {
    fetchedAt: fetchedAtRef.current,
  };
}
